"use client";

import { UserProfile } from "oidc-client-ts";
import { StateCreator } from "zustand";

export interface IUserProfile extends UserProfile {
  // additional claims
  orgid: string[];
  surgeon_npi: string;
  version: number;
  phone: string;
}

export type AuthState = {
  user_token: string | null;
  user_profile: IUserProfile | null;

  // Actions
  setUserToken: (token: string | null) => void;
  setUserProfile: (profile: IUserProfile | null) => void;
};

// states
export const createAuthSlice: StateCreator<AuthState, [], [], AuthState> = (
  set
) => ({
  user_token: null,
  user_profile: null,

  // Actions
  setUserToken: (token) => set({ user_token: token }),
  setUserProfile: (profile) => set({ user_profile: profile }),
});
